<template lang="html">
  <div>
    <product-detail v-model="product" :data-in-cart="cart" :click-addcart="addCart" />
  </div>
</template>
<script>
import ProductDetail from '@/components/product/ProductDetail'
import { getProductDetail, getProductRelated } from '@/api/product'
export default {
  components: {
    ProductDetail
  },
  data() {
    return {
      product: {
        item: {},
        related: [],
        type: 'product'
      },
      cart: {
        item: [],
        notes: '',
        currency_id: 'IDR'
      }
      // shipping: {
      //   shipping_address: '',
      //   shipping_address_is_different: 1,
      //   without_shipping: 1
      // }
    }
  },
  watch: {
    $route: function () {
      this.getDataCart()
      this.getProduct()
      this.getRelated()
    }
  },
  mounted() {
    this.getDataCart()
    this.getProduct()
    this.getRelated()
  },
  methods: {
    getDataCart() {
      const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart')
      if (LOCAL_DATA_CART) {
        this.cart = JSON.parse(LOCAL_DATA_CART)
      }
    },
    async getProduct() {
      try {
        const { data } = await getProductDetail(this.$route.params.id)
        this.product.item = data.data
      } catch (e) {
        this.product = {
          item: {},
          type: 'product'
        }
        this.$store.dispatch('showAlert', {
          type: 'error',
          show: true,
          message: e.message
        })
      }
    },
    async getRelated() {
      try {
        const { data } = await getProductRelated(this.$route.params.id)
        this.product.related = data.data
        this.product.type = 'product'
      } catch (e) {
        this.product.related = []
      }
    },
    async addCart(form, type) {
      const index = this.cart.item.findIndex(e => {
        let value = false

        if (
          (typeof e.product_type === 'undefined' || e.product_type !== 'point') &&
          form.product_id
        ) {
          if (form.product_variant_id) {
            if (
              e.product_id === form.product_id &&
              e.product_variant_id === form.product_variant_id
            ) {
              // ✅ TAMBAH CEK UOM
              if (e.uom?.id !== form.uom?.id) {
                value = false
              } else {
                if (e.addons.length > 0 || form.addons.length > 0) {
                  value = false
                } else {
                  value = true
                }
              }
            }
          } else {
            if (e.product_id === form.product_id) {
              // ✅ TAMBAH CEK UOM
              if (e.uom?.id !== form.uom?.id) {
                value = false
              } else {
                if (e.addons.length > 0 || form.addons.length > 0) {
                  value = false
                } else {
                  value = true
                }
              }
            }
          }
        }

        return value
      })

      if (index === -1) {
        this.cart.item.push({ ...form })
      } else {
        this.cart.item[index].qty += form.qty
        this.cart.item[index].checked = form.checked
        this.cart.item[index].sub_total += form.sub_total
      }

      await this.$store.dispatch('saveDataCart', this.cart)
    }
  }
}
</script>
